function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { SvgIcon } from '@material-ui/core';
export default function BookingIcon(props) {
  let output = /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 512 512"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "outline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m464 72h-56v-8a24 24 0 0 0 -48 0v8h-80v-8a24 24 0 0 0 -48 0v8h-80v-8a24 24 0 0 0 -48 0v8h-56a32.036 32.036 0 0 0 -32 32v336a32.036 32.036 0 0 0 32 32h416a32.036 32.036 0 0 0 32-32v-336a32.036 32.036 0 0 0 -32-32zm-88-8a8 8 0 0 1 16 0v32a8 8 0 0 1 -16 0zm-128 0a8 8 0 0 1 16 0v32a8 8 0 0 1 -16 0zm-128 0a8 8 0 0 1 16 0v32a8 8 0 0 1 -16 0zm360 376a16.019 16.019 0 0 1 -16 16h-416a16.019 16.019 0 0 1 -16-16v-288h448zm0-304h-448v-32a16.019 16.019 0 0 1 16-16h56v8a24 24 0 0 0 48 0v-8h80v8a24 24 0 0 0 48 0v-8h80v8a24 24 0 0 0 48 0v-8h56a16.019 16.019 0 0 1 16 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152 288h16a8 8 0 0 0 0-16h-16a8 8 0 0 0 0 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152 264h16a8 8 0 0 0 0-16h-16a8 8 0 0 0 0 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88 248h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88 280h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88 312h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72 384h128a8 8 0 0 0 8-8v-152a8 8 0 0 0 -8-8h-16v-24a8 8 0 0 0 -8-8h-64a8 8 0 0 0 -8 8v24h-32a8 8 0 0 0 -8 8v152a8 8 0 0 0 8 8zm96-16h-16v-16a8 8 0 0 1 16 0zm24 0h-8v-16a24 24 0 0 0 -48 0v16h-8v-48h64zm0-136v72h-64v-72zm-72-32h48v16h-48zm-40 32h32v112h-32zm0 128h32v8h-32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272 264a32 32 0 1 0 -32-32 32.036 32.036 0 0 0 32 32zm0-48a16 16 0 1 1 -16 16 16.019 16.019 0 0 1 16-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352 264a32 32 0 1 0 -32-32 32.036 32.036 0 0 0 32 32zm0-48a16 16 0 1 1 -16 16 16.019 16.019 0 0 1 16-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432 264a32 32 0 1 0 -32-32 32.036 32.036 0 0 0 32 32zm0-48a16 16 0 1 1 -16 16 16.019 16.019 0 0 1 16-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272 344a32 32 0 1 0 -32-32 32.036 32.036 0 0 0 32 32zm0-48a16 16 0 1 1 -16 16 16.019 16.019 0 0 1 16-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352 328a16.03 16.03 0 0 1 -15.092-10.666l-15.086 5.332a32.011 32.011 0 0 0 60.356 0l-15.086-5.332a16.03 16.03 0 0 1 -15.092 10.666z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432 280a32 32 0 1 0 32 32 32.036 32.036 0 0 0 -32-32zm0 48a16 16 0 1 1 16-16 16.019 16.019 0 0 1 -16 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272 424a32 32 0 1 0 -32-32 32.036 32.036 0 0 0 32 32zm0-48a16 16 0 1 1 -16 16 16.019 16.019 0 0 1 16-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352 424a32 32 0 1 0 -32-32 32.036 32.036 0 0 0 32 32zm0-48a16 16 0 1 1 -16 16 16.019 16.019 0 0 1 16-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432 360a32 32 0 1 0 32 32 32.036 32.036 0 0 0 -32-32zm0 48a16 16 0 1 1 16-16 16.019 16.019 0 0 1 -16 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320 168h72v16h-72z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m385.854 258.879-34.391 41.269-9.806-9.805a8 8 0 0 0 -11.314 11.314l16 16a8 8 0 0 0 5.657 2.343c.12 0 .241 0 .362-.008a8 8 0 0 0 5.784-2.871l40-48a8 8 0 0 0 -12.292-10.242z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104 400h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136 400h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168 400h16v16h-16z"
  })));
  return output;
}
